import { lazy, memo, Suspense } from 'react';
import { useAuth0Context } from '@/routes/__root.hooks';
import { hasAuth0DeveloperRole } from '@/utils/user-utils';

declare const process: {
  env: {
    NODE_ENV: string;
  };
};

const TanStackDevToolsLazy = lazy(() =>
  import('./TanStackDevTools').then(({ RouterDevTools }) => ({
    default: RouterDevTools,
  })),
);

/**
 * The MSW panel, when the dev server was started with mocking on. Both flags are statically replaced, so a
 * production build drops the branch — and with it the import of the mock handlers behind it.
 */
const MswDevToolsLazy =
  import.meta.env.DEV && import.meta.env.VITE_MSW === 'true'
    ? lazy(() => import('@qdrant-cloud-ui/testing-msw/devtools').then(({ MswDevtools }) => ({ default: MswDevtools })))
    : null;

export const DevTools = memo(() => {
  const auth = useAuth0Context();
  const isDevelopment = process.env.NODE_ENV === 'development';
  const isDeveloper = auth.isAuthenticated && hasAuth0DeveloperRole(auth.user);

  if (isDeveloper || isDevelopment) {
    return (
      <Suspense>
        <TanStackDevToolsLazy />
        {MswDevToolsLazy && <MswDevToolsLazy />}
      </Suspense>
    );
  }

  return null;
});
